import { render } from "./ViewRatingUSRow.vue?vue&type=template&id=bbc050a4&scoped=true"
import script from "./ViewRatingUSRow.vue?vue&type=script&lang=js"
export * from "./ViewRatingUSRow.vue?vue&type=script&lang=js"

import "./ViewRatingUSRow.vue?vue&type=style&index=0&id=bbc050a4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-bbc050a4"

export default script